/** @format */

// MISA-style reason codes for Receipt/Payment vouchers

export type ReceiptReasonCode =
  | "customer_debt" // Thu công nợ khách hàng
  | "advance_recovery" // Thu hồi tạm ứng
  | "other_income" // Thu khác
  | "vat_refund" // Hoàn thuế VAT
  | "bank_withdrawal"; // Rút tiền từ ngân hàng

export type PaymentReasonCode =
  | "supplier_payment" // Trả tiền nhà cung cấp
  | "advance_payment" // Tạm ứng nhân viên
  | "bank_deposit" // Nộp tiền vào ngân hàng
  | "expense" // Chi phí hoạt động
  | "other_expense"; // Chi khác

export type VoucherStatus = "draft" | "pending" | "approved" | "cancelled";

// Display labels for reason codes
export const RECEIPT_REASON_OPTIONS: Array<{
  value: ReceiptReasonCode;
  label: string;
  debitAccount: string;
  creditAccount: string;
}> = [
  {
    value: "customer_debt",
    label: "Thu công nợ khách hàng",
    debitAccount: "111", // Tiền mặt
    creditAccount: "131", // Phải thu khách hàng
  },
  {
    value: "advance_recovery",
    label: "Thu hồi tạm ứng",
    debitAccount: "111",
    creditAccount: "141", // Tạm ứng
  },
  {
    value: "vat_refund",
    label: "Hoàn thuế VAT",
    debitAccount: "111",
    creditAccount: "133", // Thuế GTGT được khấu trừ
  },
  {
    value: "bank_withdrawal",
    label: "Rút tiền từ ngân hàng",
    debitAccount: "111",
    creditAccount: "112", // Tiền gửi ngân hàng
  },
  {
    value: "other_income",
    label: "Thu khác",
    debitAccount: "111",
    creditAccount: "711", // Thu nhập khác
  },
];

export const PAYMENT_REASON_OPTIONS: Array<{
  value: PaymentReasonCode;
  label: string;
  debitAccount: string;
  creditAccount: string;
}> = [
  {
    value: "supplier_payment",
    label: "Trả tiền nhà cung cấp",
    debitAccount: "331", // Phải trả người bán
    creditAccount: "111",
  },
  {
    value: "advance_payment",
    label: "Tạm ứng nhân viên",
    debitAccount: "141", // Tạm ứng
    creditAccount: "111",
  },
  {
    value: "bank_deposit",
    label: "Nộp tiền vào ngân hàng",
    debitAccount: "112", // Tiền gửi ngân hàng
    creditAccount: "111",
  },
  {
    value: "expense",
    label: "Chi phí hoạt động",
    debitAccount: "642", // Chi phí QLDN
    creditAccount: "111",
  },
  {
    value: "other_expense",
    label: "Chi khác",
    debitAccount: "811", // Chi phí khác
    creditAccount: "111",
  },
];

export const VOUCHER_STATUS_OPTIONS: Array<{
  value: VoucherStatus;
  label: string;
  color: string;
}> = [
  { value: "draft", label: "Nháp", color: "gray" },
  { value: "pending", label: "Chờ duyệt", color: "yellow" },
  { value: "approved", label: "Đã duyệt", color: "green" },
  { value: "cancelled", label: "Đã hủy", color: "red" },
];

// Helper to get reason option by code
export const getReceiptReasonOption = (code: ReceiptReasonCode) =>
  RECEIPT_REASON_OPTIONS.find((opt) => opt.value === code);

export const getPaymentReasonOption = (code: PaymentReasonCode) =>
  PAYMENT_REASON_OPTIONS.find((opt) => opt.value === code);

export const getVoucherStatusOption = (status: VoucherStatus) =>
  VOUCHER_STATUS_OPTIONS.find((opt) => opt.value === status);
